import { render, staticRenderFns } from "./DefectDescriptionModal.vue?vue&type=template&id=7a0d6b44"
import script from "./DefectDescriptionModal.vue?vue&type=script&lang=js"
export * from "./DefectDescriptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports